const AudienceNetworkIcon = ({ className, ...props }) => {
    return (
        <svg 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path 
                d="M12 5.56738C15.3609 5.56738 17.9228 8.04477 17.9229 10.9092C17.9229 13.7736 15.361 16.252 12 16.252C8.63905 16.252 6.07715 13.7736 6.07715 10.9092C6.07723 8.04477 8.6391 5.56738 12 5.56738Z" 
                stroke="currentColor" 
                strokeWidth="2.15385"
            />
            <path 
                d="M19.0005 16.605L16.8466 14.4512L14.1543 15.7973L16.8466 18.7589H19.0005V16.605Z" 
                fill="currentColor"
            />
            <path 
                d="M5.26938 16.605L7.42323 14.4512L10.3848 15.7973L7.42323 18.7589H5.26938V16.605Z" 
                fill="currentColor"
            />
        </svg>
    )
}

export default AudienceNetworkIcon